module.exports = __webpack_public_path__ + "shanz/static/media/about-top-banner.d438bc75.png";